(() => {
  const media = window.matchMedia('(max-width: 767px)');
  let cleanup = () => {};
  const bind = () => {
    cleanup();
    const header = document.querySelector('[data-teching-header]');
    const nav = header?.querySelector('#MobileNav');
    const toggle = header?.querySelector('[data-menu-toggle]');
    if (!header || !nav || !toggle) return;
    const controller = new AbortController();
    const options = {signal: controller.signal};
    let open = false;
    let restoreFocus = true;
    const protectedNodes = new Map();
    const updateOffset = () => document.documentElement.style.setProperty('--mobile-header-bottom', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    const restorePage = () => {
      for (const [node, previous] of protectedNodes) node.inert = previous;
      protectedNodes.clear();
      document.documentElement.classList.remove('teching-mobile-menu-open');
    };
    const sync = () => {
      const next = media.matches && !nav.hidden;
      updateOffset();
      toggle.setAttribute('aria-expanded', String(!nav.hidden));
      toggle.setAttribute('aria-label', !nav.hidden ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
      if (next === open) return;
      open = next;
      if (open) {
        document.documentElement.classList.add('teching-mobile-menu-open');
        document.querySelectorAll('main#MainContent, footer.footer').forEach(node => {
          protectedNodes.set(node, node.inert);
          node.inert = true;
        });
        nav.querySelector('a[href]')?.focus({preventScroll:true});
      } else {
        restorePage();
        if (restoreFocus && nav.contains(document.activeElement)) toggle.focus({preventScroll:true});
        restoreFocus = true;
      }
    };
    const close = (focus = true) => {
      const wasOpen = open;
      restoreFocus = focus;
      nav.hidden = true;
      sync();
      if (focus && wasOpen) toggle.focus({preventScroll:true});
    };
    const observer = new MutationObserver(sync);
    observer.observe(nav, {attributes:true,attributeFilter:['hidden']});
    const resizeObserver = new ResizeObserver(updateOffset);
    resizeObserver.observe(header);
    document.addEventListener('click', event => {
      if (!media.matches) return;
      if (event.target.closest('#MobileNav a, .header-brand')) close(false);
      else if (event.target.closest('[data-search-open], .market-picker>summary') && open) close(false);
      else if (open && !header.contains(event.target)) close();
    }, options);
    document.addEventListener('keydown', event => {
      if (!open) return;
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...header.querySelectorAll('a[href],button,summary,select,input')].filter(node => !node.disabled && node.getClientRects().length > 0);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }, options);
    const onMediaChange = () => { if (!media.matches) close(false); else sync(); };
    media.addEventListener('change', onMediaChange, options);
    window.addEventListener('scroll', () => { if (open) updateOffset(); }, {...options,passive:true});
    window.addEventListener('resize', updateOffset, {...options,passive:true});
    sync();
    cleanup = () => { controller.abort(); observer.disconnect(); resizeObserver.disconnect(); restorePage(); };
  };
  bind();
  document.addEventListener('shopify:section:load', event => { if (event.target.querySelector('[data-teching-header]')) bind(); });
})();
